import React from 'react';

import { ChevronDown } from 'components/icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import style from './style.module.scss';
import { localeLang } from '../../../i18n';
import { actions } from '../_redux/Language';

const { setLang } = actions;

const LocaleSwitcher = ({ lang, isHome }) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const wrapperRef = React.useRef(null);

  const otherLocales = localeLang.locales.filter((locale) => locale !== lang);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const handleLocaleChange = (newLocale) => {
    dispatch(setLang(newLocale));
    i18n.changeLanguage(newLocale);
    setDropdownOpen(false);
  };

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <div className={`${style.LangWrapper} position-relative`} ref={wrapperRef}>
      <button
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className={`${isHome ? style.light : style.dark} ${
          style.LangBtn
        } d-flex align-items-center gap-2`}
      >
        <span>{lang}</span>
        <ChevronDown />
      </button>
      {dropdownOpen && (
        <ul
          className={`${isHome ? style.light : style.dark} ${style.MultiLang} `}
        >
          {otherLocales.map((locale, index) => (
            <li
              key={index}
              value={locale}
              onClick={() => handleLocaleChange(locale)}
            >
              {locale}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LocaleSwitcher;
